var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import * as S from './IconRight.styles';
import { Spinner } from '../../../Spinner';
import { ChevronDown, ChevronUp } from '@olxbr/ds-icons';
export const IconRight = _a => {
  var {
      state,
      isOpen
    } = _a,
    props = __rest(_a, ["state", "isOpen"]);
  if (state === 'loading') {
    return React.createElement(S.Wrapper, null, React.createElement(Spinner, {
      "aria-label": props['aria-label'] || '',
      size: "extra-small"
    }));
  }
  if (isOpen) {
    return React.createElement(S.Wrapper, null, React.createElement(ChevronUp, null));
  }
  return React.createElement(S.Wrapper, null, React.createElement(ChevronDown, null));
};
IconRight.displayName = 'IconRight';